import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { selectedVariantId } from "../store/product-store";
import { variantBadges } from "../store/product-store";
import { effect } from "@preact/signals-core";

@customElement("badges-pp")
export class BadgesPP extends LitElement {
  @property({ type: Object }) badge: { type: string; value: number | null } | null = null;

  constructor() {
    super();

    // Listen to changes in the selected variant and update the badge
    effect(() => {
      const selectedId = selectedVariantId.value;
      const badges = variantBadges.value;
      this.badge = badges.find((b: any) => b.variantId === selectedId) ?? null;
    });
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this; // Render in the light DOM
  }

  render() {
    if (!this.badge) {
      return html`<span>No badge available</span>`;
    }

    const { type, value } = this.badge;

    switch (type) {
      case "exclusive-offer":
        return html`<span class="discount-badge">Exclusive Offer</span>`;
      case "special-offer":
        return html`<span class="discount-badge">Special Offer</span>`;
      case "regular":
        return html`<span class="discount-badge">${value}% Off</span>`;
      default:
        return html`<span>Unknown badge type</span>`;
    }
  }
}
